/**
 * Service cards shown in the "Waarvoor kan je bij mij terecht?" section.
 */
export const services = [
  {
    tag: 'Behandeling',
    title: 'Therapie & traumaverwerking',
    body: 'Voor traumaverwerking (enkelvoudig of complex/vroegkinderlijk), angst- en paniekklachten, somberheid, burn-out, negatief zelfbeeld, rouw en problemen rond een nieuwe levensfase.',
    methods: ['CGT', 'EMDR', 'ACT', 'Schema', 'MBCT'],
  },
  {
    tag: 'Diagnostiek',
    title: 'Psychodiagnostisch onderzoek',
    body: 'Vragenlijsten en interviews met jou en soms een naaste. Resultaten worden besproken in een adviesgesprek en verwerkt in een verslag — denk aan ADHD, autisme of persoonlijkheid.',
    methods: ['Intake', 'Vragenlijsten', 'Adviesgesprek', 'Verslag'],
  },
  {
    tag: 'Inventarisatie',
    title: 'De juiste hulp vinden',
    body: 'Verdwaald in het Nederlandse GGZ-systeem? Met kennis van het systeem en een uitgebreid netwerk help ik je de juiste behandelvorm en behandelaar te vinden.',
    methods: ['GGZ-routing', 'Doorverwijzing', '75 € / uur'],
  },
];
